export default __webpack_public_path__ + "static/media/red-3.a567c475.png";